import React from 'react';
import { useAuth } from '../context/AuthContext';
import { ShieldOff, Lock } from 'lucide-react';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { currentUser, isAdmin, isManager, isTechnician } = useAuth();

  // Admin always has access to everything
  if (isAdmin) {
    return children;
  }

  if (requiredPermission === 'team' && (isManager || currentUser?.permissions?.includes('team'))) {
    return children;
  }

  if (requiredPermission === 'tasks' && isTechnician) {
    return children;
  }

  // Check if user has the required permission
  const hasPermission = currentUser?.permissions?.includes(requiredPermission);

  if (!hasPermission) {
    // Show "No Access" page instead of redirecting
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center border border-slate-200">
          <div className="mx-auto w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mb-6">
            <ShieldOff className="w-10 h-10 text-red-600" />
          </div>
          
          <h1 className="text-2xl font-bold text-slate-800 mb-3">
            Acceso Denegado
          </h1>
          
          <p className="text-slate-600 mb-6">
            No tienes permisos para acceder a esta página. Contacta al administrador si necesitas acceso.
          </p>
          
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6">
            <div className="flex items-start gap-3">
              <Lock className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
              <div className="text-left">
                <p className="text-sm font-medium text-amber-800 mb-1">
                  Permiso requerido:
                </p>
                <p className="text-sm text-amber-700">
                  {requiredPermission === 'invoices' && 'Facturación'}
                  {requiredPermission === 'schedules' && 'Horarios'}
                  {requiredPermission === 'loans' && 'Préstamos'}
                  {requiredPermission === 'tasks' && 'Solicitudes'}
                  {requiredPermission === 'team' && 'Usuarios'}
                </p>
              </div>
            </div>
          </div>
          
          <button
            onClick={() => window.location.href = '#/'}
            className="w-full bg-primary text-white px-6 py-3 rounded-xl font-medium hover:bg-primary/90 transition-colors"
          >
            Volver al Dashboard
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
